import api from '@pray/shared/utils/api';

// The parse endpoint accepts delimiter/quote as NAMED constants on the wire, not raw
// characters. The wizard keeps the real character in state (papaparse and the live preview
// re-parse need it), so we translate character → name here, at the request boundary. These
// names MUST match the server allow-list (server_pray services/catalogs/constants.ts):
// COMMA=',' SEMICOLON=';' TAB='\t' PIPE='|'; DOUBLE_QUOTE='"' SINGLE_QUOTE="'".
const DELIMITER_NAME_BY_CHAR: Record<string, string> = {
  ',': 'COMMA',
  ';': 'SEMICOLON',
  '\t': 'TAB',
  '|': 'PIPE',
};
const QUOTE_NAME_BY_CHAR: Record<string, string> = {
  '"': 'DOUBLE_QUOTE',
  "'": 'SINGLE_QUOTE',
};

/** columnMapping: catalog field name → CSV column header */
type Props = {
  artistId: string;
  catalogId: string;
  s3Key: string;
  columnMapping: Record<string, string>;
  delimiter?: string;
  quote?: string;
};
export async function postParseCsv({ artistId, catalogId, s3Key, columnMapping, delimiter, quote }: Props) {
  if (!artistId) throw new Error('Artist ID is required');
  // Props are camelCase (s3Key/columnMapping) for the camelCase caller (the CSV wizard),
  // but the wire shape is snake_case like the other catalog endpoints: we translate to
  // { s3_key, column_mapping } on the way out. delimiter/quote arrive as the literal
  // characters the UI works in and are translated to their named constant here; when absent
  // (or off-list) the key is dropped so the server applies its comma / " defaults
  // (JSON.stringify drops undefined keys). Unmapped fields carry an empty column value —
  // strip them so the server only sees real mappings. The endpoint returns { import_id }; we
  // unwrap the envelope one level (see getCatalogs.ts) and re-key import_id → importId so the
  // caller stays untouched.
  const cleanedMapping = Object.fromEntries(Object.entries(columnMapping).filter(([, column]) => Boolean(column)));
  const res = await api.executePostRequest<{ data: { import_id: string } }>(
    `/web/studio/artists/${artistId}/catalogs/${catalogId}/items/parse`,
    {
      s3_key: s3Key,
      column_mapping: cleanedMapping,
      delimiter: delimiter ? DELIMITER_NAME_BY_CHAR[delimiter] : undefined,
      quote: quote ? QUOTE_NAME_BY_CHAR[quote] : undefined,
    });
  return { importId: res.data.data.import_id };
}
